(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-category-shortcuts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('az-category-shortcuts')) {
    customElements.define('az-category-shortcuts', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target.closest('a.az-shortcut');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const href = link.getAttribute('href');
          if (!href || !href.startsWith('#')) return;
          const target = document.getElementById(href.slice(1));
          if (!target) return;
          event.preventDefault();
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('az-collection-tabs')) {
    customElements.define('az-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.tabs = Array.from(this.querySelectorAll('.az-tab'));
        this.panels = Array.from(this.querySelectorAll('.az-panel'));
        if (!this.tabs.length) return;
        this.querySelector('.az-tabs').hidden = false;
        this.querySelectorAll('.az-fallback-title').forEach(el => { el.hidden = true; });
        this.panels.forEach((panel, i) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.tabs[i].id);
          panel.tabIndex = 0;
        });
        this.resizeObserver = new ResizeObserver(() => this.updateCarousels());
        this.panels.forEach(panel => {
          const track = panel.querySelector('.az-grid');
          track.addEventListener('scroll', () => this.updateCarousel(panel), { ...options, passive: true });
          panel.querySelector('.az-prev').addEventListener('click', () => this.moveCarousel(panel, -1), options);
          panel.querySelector('.az-next').addEventListener('click', () => this.moveCarousel(panel, 1), options);
          this.resizeObserver.observe(track);
        });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.activate(next);
            this.tabs[next].focus();
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.activate(index);
        }, options);
        this.activate(0);
      }
      activate(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        this.updateCarousels();
      }
      moveCarousel(panel, direction) {
        const track = panel.querySelector('.az-grid');
        const cards = Array.from(track.children);
        if (!cards.length) return;
        const step = cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
        const visible = Math.max(1, Math.round((track.clientWidth + (parseFloat(getComputedStyle(track).gap) || 0)) / step));
        track.scrollBy({ left: direction * step * visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateCarousel(panel) {
        if (panel.hidden) return;
        const track = panel.querySelector('.az-grid');
        const controls = panel.querySelector('.az-controls');
        const maximum = track.scrollWidth - track.clientWidth;
        controls.hidden = maximum <= 2;
        const left = Math.max(0, track.scrollLeft);
        panel.querySelector('.az-prev').disabled = left <= 2;
        panel.querySelector('.az-next').disabled = left >= maximum - 2;
        const cards = Array.from(track.children);
        if (!cards.length) return;
        const bounds = track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ bounds: card.getBoundingClientRect(), index })).filter(card => card.bounds.right > bounds.left + 2 && card.bounds.left < bounds.right - 2);
        if (visible.length) {
          const label = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${cards.length}`;
          const counter = panel.querySelector('.az-counter');
          if (counter.textContent !== label) counter.textContent = label;
        }
      }
      updateCarousels() { this.panels.forEach(panel => this.updateCarousel(panel)); }
      disconnectedCallback() { this.abortController?.abort(); this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
